import moEngageUtils from "./moengage";

const trackEvent = (eventName = "", eventData = {}) => {
  const userInfo = JSON.parse(localStorage.getItem("user_info") || "{}");
  const eventDataWithUser = {
    ...eventData,
    mobile_number: userInfo?.contactNo || "NA",
    therapy_area: userInfo?.therapy_area || "NA",
    disease: userInfo?.disease || "NA",
  };
  try {
    moEngageUtils.trackEvent(eventName, eventDataWithUser);
  } catch (error) {
    console.error("Error tracking event:", error);
  }
};

const setUserAttributes = (attributes = {}) => {
  try {
    moEngageUtils.setUserAttributes(attributes);
  } catch (error) {
    console.error("Error tracking event:", error);
  }
};

const logout = () => {
  try {
    moEngageUtils.logout();
  } catch (error) {
    console.error("Error logging out of moengage:", error);
  }
};

export const initAnalytics = () => {
  moEngageUtils.initialize();
};

export { trackEvent, setUserAttributes, logout };
